import type { ExportButtonSize, ExportTriggerStyle } from "./types";

// "sm" matches the overview modal's action bar; "md" matches the header's Button size
export const TRIGGER_STYLE_BY_SIZE: Record<
  ExportButtonSize,
  ExportTriggerStyle
> = {
  sm: {
    className:
      "inline-flex items-center gap-1.5 rounded-lg bg-green-600 px-3 py-1.5 text-xs font-medium text-white transition-colors hover:bg-green-700",
    iconSize: 14,
  },
  md: {
    className:
      "inline-flex items-center gap-2 rounded-lg bg-green-600 px-3 py-2 text-sm font-medium text-white transition-colors hover:bg-green-700",
    iconSize: 18,
  },
};
